import React from 'react';
import { useDeleteVirtualMedicine } from '../../../../apis/virtual-medicines/hooks/useDeleteVirtualMedicine';
import { DangerButton } from '../../../../healtheraComponents';
import { useHistory } from 'react-router';
import { enqueueSnackbar } from 'notistack';

interface DeleteVirtualMedicineProps {
  id: string;
}

const DeleteVirtualMedicine = ({ id }: DeleteVirtualMedicineProps) => {
  const { deleteVirtualMedicine, isLoading } = useDeleteVirtualMedicine();
  const history = useHistory();

  const handleDelete = async () => {
    const shouldDelete = window.confirm('Are you sure you want to delete this virtual medicine?');

    if (shouldDelete) {
      await deleteVirtualMedicine(id);
      enqueueSnackbar('Virtual medicine deleted', { variant: 'success' });
      history.goBack();
    }
  };

  return (
    <DangerButton disabled={isLoading} onClick={handleDelete}>
      Delete
    </DangerButton>
  );
};

export default DeleteVirtualMedicine;
